<div class="entire">
  <form [formRoot]="carePlanForm" autocomplete="off">
    <mat-grid-list cols="4">
      <mat-grid-tile>
        <mat-grid-tile-header
          id="noticing"
          pTooltip="What is important?
                    • Assessment Data
                    • History Care Provider Orders
                    • Medications
                    • Clinical Data
                    • Other"
          tooltipPosition="top"
        >
          <div class="header"><u>Noticing</u></div>
        </mat-grid-tile-header>
        <textarea [formField]="carePlanForm.noticing"></textarea>
      </mat-grid-tile>

      <mat-grid-tile>
        <mat-grid-tile-header
          id="interpreting"
          pTooltip="• What nursing problems can you identify?
                    • What is important about the medications?
                    • What are the priority nursing problems?
                    • What are outcomes that address the priority problems?
                    • What nursing interventions assist in the achievement of the assigned outcomes?"
          tooltipPosition="top"
        >
          <u>Interpreting</u>
        </mat-grid-tile-header>
        <textarea [formField]="carePlanForm.interpreting"></textarea>
      </mat-grid-tile>

      <mat-grid-tile>
        <mat-grid-tile-header
          id="responding"
          pTooltip="• What are priority nursing interventions?
                    • What care provider orders should be implemented?
                    • Who should the nurse collaborate with?
                    • What can the nurse delegate to the UAP?
                    • What are the teaching points?
                    • What are potential problems and what nursing interventions help to prevent them?"
          tooltipPosition="top"
        >
          <u>Responding</u>
        </mat-grid-tile-header>
        <textarea [formField]="carePlanForm.responding"></textarea>
      </mat-grid-tile>

      <mat-grid-tile>
        <mat-grid-tile-header
          id="reflecting"
          pTooltip="• What signs and symptoms show that the outcomes were met? (Provide examples)
                    • Is the patient improving? (Provide examples)
                    • What signs and symptoms show that the outcomes were NOT met? (Provide examples)
                    • Is the patient declining? (Provide examples)
                    • What next?"
          tooltipPosition="top"
        >
          <u>Reflecting</u>
        </mat-grid-tile-header>
        <textarea [formField]="carePlanForm.reflecting"></textarea>
      </mat-grid-tile>
    </mat-grid-list>
  </form>
  <button pButton class="add-assessment-btn" color="accent" (click)="onSave()">Save</button>
  <p-toast position="top-right"></p-toast>
</div>
